import axios from "axios";

const apiClient = axios.create({
  baseURL:
    "https://shopping-list-share-8efd6-default-rtdb.europe-west1.firebasedatabase.app",
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export default {
  getList(idToken) {
    return apiClient.get("/list.json" + "?auth=" + idToken);
  },
  putList(list, idToken) {
    return apiClient.put("/list.json" + "?auth=" + idToken, list);
  },
};
